import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-labor-cost-modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "labor-cost-section" }
const _hoisted_5 = {
  key: 0,
  class: "labor-cost-card"
}
const _hoisted_6 = { class: "labor-cost-title-bar" }
const _hoisted_7 = { class: "labor-cost-table" }
const _hoisted_8 = { class: "amount" }
const _hoisted_9 = { class: "amount" }
const _hoisted_10 = { class: "amount highlight" }
const _hoisted_11 = { class: "amount highlight" }
const _hoisted_12 = { class: "amount" }
const _hoisted_13 = { class: "amount" }
const _hoisted_14 = { class: "amount" }
const _hoisted_15 = { class: "labor-cost-summary" }
const _hoisted_16 = { class: "summary-item" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 1,
  class: "no-data-message"
}
const _hoisted_19 = { class: "job-summary-section" }
const _hoisted_20 = {
  key: 0,
  class: "job-summary-card"
}
const _hoisted_21 = { class: "job-summary-table" }
const _hoisted_22 = { class: "job-category-cell" }
const _hoisted_23 = { class: "amount center" }
const _hoisted_24 = { class: "amount" }
const _hoisted_25 = { class: "amount" }
const _hoisted_26 = { class: "amount" }
const _hoisted_27 = { class: "total-row" }
const _hoisted_28 = { class: "amount center" }
const _hoisted_29 = { class: "amount" }
const _hoisted_30 = { class: "amount" }
const _hoisted_31 = { class: "amount" }
const _hoisted_32 = {
  key: 1,
  class: "no-data-message compact"
}
const _hoisted_33 = { class: "modal-footer" }

import { ref, computed } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import { ltcsApi, commonWageApi } from '@/services/api';
import { formatLaborCostJobCategory } from '@/policies';
import {
  getCommonWageLedgerGrossPay,
  getCommonWageLedgerEmployerInsurance,
  getCommonWageLedgerRetirement,
  getCommonLaborCostJobCategoryOrder,
} from '@/policies/commonWageSettingPolicy';
import type { CommonWageListRow } from '@/types/commonWage';

interface LaborCostRow {
  yearMonth?: string;
  facilityType?: string;
  totalCost?: number;
  totalAdd?: number;
  laborCost?: number;
  laborAdd?: number;
  nonLaborCost?: number;
  nonLaborAdd?: number;
  selfPayCost?: number;
}

interface JobSummaryRow {
  category: string;
  count: number;
  grossPay: number;
  employerInsurance: number;
  retirement: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageLaborCostModal',
  props: {
    memberCode: {},
    year: {},
    month: {},
    bizGubun: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const showModal = ref(false);
const loading = ref(false);
const laborCost = ref<LaborCostRow | null>(null);
const wageRows = ref<CommonWageListRow[]>([]);

const yearMonth = computed(
  () => `${props.year}${String(props.month).padStart(2, '0')}`
);

const formatYearMonth = (ym?: string) => {
  if (!ym || ym.length < 6) return '-';
  return `${ym.slice(0, 4)}.${ym.slice(4, 6)}`;
};

const formatNumber = (num?: number | null) => {
  const n = Number(num) || 0;
  return n.toLocaleString();
};

const isDirectorJob = (job?: string) => {
  if (!job) return false;
  return job.includes('센터장') || job.includes('시설장');
};

const resolveJobCategory = (row: CommonWageListRow): string => {
  const job = (row.ce_position || '').trim() || '미분류';
  return formatLaborCostJobCategory(job);
};

const jobSummaryRows = computed<JobSummaryRow[]>(() => {
  const map = new Map<string, JobSummaryRow>();

  wageRows.value.forEach((row) => {
    const job = (row.ce_position || '').trim() || '미분류';
    if (isDirectorJob(job)) return;
    if (getCommonWageLedgerGrossPay(row) <= 0) return;

    const category = resolveJobCategory(row);
    const grossPay = getCommonWageLedgerGrossPay(row);
    const retirement = getCommonWageLedgerRetirement(row);
    const employerInsurance = getCommonWageLedgerEmployerInsurance(row);

    const existing = map.get(category);
    if (existing) {
      existing.count += 1;
      existing.grossPay += grossPay;
      existing.employerInsurance += employerInsurance;
      existing.retirement += retirement;
    } else {
      map.set(category, {
        category,
        count: 1,
        grossPay,
        employerInsurance,
        retirement,
      });
    }
  });

  return Array.from(map.values()).sort((a, b) => {
    const orderA = getCommonLaborCostJobCategoryOrder(a.category);
    const orderB = getCommonLaborCostJobCategoryOrder(b.category);
    if (orderA !== orderB) return orderA - orderB;
    return a.category.localeCompare(b.category, 'ko');
  });
});

const jobSummaryTotals = computed(() => {
  return jobSummaryRows.value.reduce(
    (acc, row) => {
      acc.count += row.count;
      acc.grossPay += row.grossPay;
      acc.employerInsurance += row.employerInsurance;
      acc.retirement += row.retirement;
      return acc;
    },
    { count: 0, grossPay: 0, employerInsurance: 0, retirement: 0 }
  );
});

const loadData = async () => {
  if (!props.memberCode) {
    alert('시설 코드가 없습니다.');
    return;
  }

  loading.value = true;
  laborCost.value = null;
  wageRows.value = [];

  const settled = await Promise.allSettled([
    ltcsApi.getLaborCost(props.memberCode, yearMonth.value, props.bizGubun || ''),
    commonWageApi.getList(props.memberCode, {
      year: props.year,
      month: props.month,
      bizGubun: props.bizGubun || '',
    }),
  ]);

  const [laborSettled, wageSettled] = settled;
  const failures: string[] = [];

  if (laborSettled.status === 'fulfilled') {
    if (laborSettled.value.data?.data) {
      laborCost.value = laborSettled.value.data.data;
    }
  } else {
    failures.push('심사결정금액');
    console.error('인건비지출내역 조회 오류:', laborSettled.reason);
  }

  if (wageSettled.status === 'fulfilled') {
    if (wageSettled.value.data?.success) {
      wageRows.value = (wageSettled.value.data.data || []) as CommonWageListRow[];
    }
  } else {
    failures.push('종사자 집계');
    console.error('인건비지출내역 임금 조회 오류:', wageSettled.reason);
  }

  loading.value = false;

  if (failures.length > 0 && !laborCost.value && wageRows.value.length === 0) {
    alert(`인건비지출내역 조회 실패: ${failures.join(', ')}`);
  }
};

const open = async () => {
  showModal.value = true;
  await loadData();
};

const close = () => {
  showModal.value = false;
};

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "home-labor-cost-modal-overlay",
          onClick: _withModifiers(close, ["self"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", null, "인건비 지출내역 (" + _toDisplayString(__props.year) + "년 " + _toDisplayString(__props.month) + "월)", 1),
              _createElementVNode("button", {
                type: "button",
                class: "close-btn",
                onClick: close
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(LoadingOverlay, {
                show: loading.value,
                text: "불러오는 중..."
              }, null, 8, ["show"]),
              (!loading.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_4, [
                      (laborCost.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, " (" + _toDisplayString(formatYearMonth(laborCost.value.yearMonth || yearMonth.value)) + ") " + _toDisplayString(laborCost.value.facilityType || '-') + " 심사결정금액 ", 1),
                            _createElementVNode("table", _hoisted_7, [
                              _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", { class: "header-row-1" }, [
                                  _createElementVNode("th", { colspan: "2" }, "① 장기요양급여비용(②+③+④)"),
                                  _createElementVNode("th", { colspan: "2" }, "② 인건비 비율 반영"),
                                  _createElementVNode("th", { colspan: "2" }, "③ 인건비 비율 미반영"),
                                  _createElementVNode("th", null, "④ 본인부담금")
                                ]),
                                _createElementVNode("tr", { class: "header-row-2" }, [
                                  _createElementVNode("th", null, "비용"),
                                  _createElementVNode("th", null, "가산"),
                                  _createElementVNode("th", null, "비용"),
                                  _createElementVNode("th", null, "가산"),
                                  _createElementVNode("th", null, "비용"),
                                  _createElementVNode("th", null, "가산"),
                                  _createElementVNode("th", null, "비용")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_8, _toDisplayString(formatNumber(laborCost.value.totalCost)), 1),
                                  _createElementVNode("td", _hoisted_9, _toDisplayString(formatNumber(laborCost.value.totalAdd)), 1),
                                  _createElementVNode("td", _hoisted_10, _toDisplayString(formatNumber(laborCost.value.laborCost)), 1),
                                  _createElementVNode("td", _hoisted_11, _toDisplayString(formatNumber(laborCost.value.laborAdd)), 1),
                                  _createElementVNode("td", _hoisted_12, _toDisplayString(formatNumber(laborCost.value.nonLaborCost)), 1),
                                  _createElementVNode("td", _hoisted_13, _toDisplayString(formatNumber(laborCost.value.nonLaborAdd)), 1),
                                  _createElementVNode("td", _hoisted_14, _toDisplayString(formatNumber(laborCost.value.selfPayCost)), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "인건비 반영 합계", -1)),
                                _createElementVNode("span", _hoisted_17, _toDisplayString(formatNumber((laborCost.value.laborCost || 0) + (laborCost.value.laborAdd || 0))) + "원 ", 1)
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_v_icon, {
                              size: "40",
                              color: "grey-lighten-2"
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode("mdi-file-document-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[4] || (_cache[4] = _createElementVNode("p", null, "해당 조건의 인건비지출내역이 없습니다.", -1))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "job-summary-title" }, "종사자구분별 집계", -1)),
                      (jobSummaryRows.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("table", _hoisted_21, [
                              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "종사자구분"),
                                  _createElementVNode("th", null, "인원수"),
                                  _createElementVNode("th", null, "임금총액"),
                                  _createElementVNode("th", null, "사회보험 기관부담금총액"),
                                  _createElementVNode("th", null, "퇴직적립금 총액")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobSummaryRows.value, (row) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: row.category
                                  }, [
                                    _createElementVNode("td", _hoisted_22, _toDisplayString(row.category), 1),
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(row.count) + "명", 1),
                                    _createElementVNode("td", _hoisted_24, _toDisplayString(formatNumber(row.grossPay)), 1),
                                    _createElementVNode("td", _hoisted_25, _toDisplayString(formatNumber(row.employerInsurance)), 1),
                                    _createElementVNode("td", _hoisted_26, _toDisplayString(formatNumber(row.retirement)), 1)
                                  ]))
                                }), 128)),
                                _createElementVNode("tr", _hoisted_27, [
                                  _cache[5] || (_cache[5] = _createElementVNode("td", null, "합계", -1)),
                                  _createElementVNode("td", _hoisted_28, _toDisplayString(jobSummaryTotals.value.count) + "명", 1),
                                  _createElementVNode("td", _hoisted_29, _toDisplayString(formatNumber(jobSummaryTotals.value.grossPay)), 1),
                                  _createElementVNode("td", _hoisted_30, _toDisplayString(formatNumber(jobSummaryTotals.value.employerInsurance)), 1),
                                  _createElementVNode("td", _hoisted_31, _toDisplayString(formatNumber(jobSummaryTotals.value.retirement)), 1)
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("p", null, "저장된 급여 데이터가 없습니다.", -1)
                          ]))]))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_v_btn, {
                variant: "text",
                class: "btn-close",
                onClick: close
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("닫기", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})